import { Injectable } from '@angular/core';
import { GenericService } from 'src/app/core/services/generic.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private genericService: GenericService) { }

  login(user) {
    return this.genericService.addObject('auth/login', user);
  }
}
